export default __webpack_public_path__ + "static/media/check_circle_Green.21842256.svg";